export default "/images/vendor/@coreui/icons/svg/flag/cif-cr.svg?2046de3d13420731649347d4d0324c1d";